import type { RouteObject } from "react-router-dom";
import { PagesSpecialsManagerUiDisplay } from "./Display";
import { PagesSpecialsManagerUiResults } from "./Display/Results";
import { PagesSpecialsManagerUiModal } from "./Display/Modal";

export const PagesSpecialsManagerUiRoutes: RouteObject[] = [
  {
    path: "specialsManager",
    element: <PagesSpecialsManagerUiDisplay />,
    children: [
      {
        path: ":searchValue",
        element: <PagesSpecialsManagerUiResults />,
        children: [
          {
            path: ":record",
            element: <PagesSpecialsManagerUiModal />
          }
        ]
      }
    ]
  }
];
